import {PldPage} from './PldPage';
export default PldPage;